module.exports = __webpack_public_path__ + "img/4.09e48c0b.jpg";